import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Redirection: FC = () => {
  // Params
  const [params] = useSearchParams();

  // Redirect
  useEffect(() => {
    const token = params.get('token');
    const role = params.get('role');
    const isStripe = params.get('stripe');

    if (isStripe === 'true' && role === 'pro') {
      console.log('PRO APP HOME SCREEN OPEN');
      window.location.href = `rylyfapp://stripe=true`;
    }

    if (token && role === 'pro') {
      window.location.href = `rylyfapp://resetPassword=true/?token=${token}`;
    }
    if (token && role === 'customer') {
      window.location.href = `rylyf://resetPassword=true/?token=${token}`;
    }
  }, [params]);
  return (
    <div>
      <p>Redirecting...</p>
    </div>
  );
};

export default Redirection;
